import { Transform } from 'ff-canvas';

export type TransformParameters = {
    sceneWidth: number;
    sceneHeight: number;
    variantViewboxX: number;
    variantViewboxY: number;
    variantViewboxWidth: number;
    variantViewboxHeight: number;
    designViewboxWidth: number;
    designViewboxHeight: number;
};

export type UndoViewbox = {
    scaling: number;
    offsetX: number;
    offsetY: number;
};

export const calculateVariantToDesignScale = (
    variantViewboxHeight: number, variantViewboxWidth: number,
    designViewboxHeight: number, designViewboxWidth: number) => {

    const sceneRatio = variantViewboxHeight / variantViewboxWidth;
    const designRatio = designViewboxHeight / designViewboxWidth;

    const widthScale = variantViewboxWidth / designViewboxWidth;
    const heightScale = variantViewboxHeight / designViewboxHeight;

    return sceneRatio >= designRatio
        ? widthScale
        : heightScale;
};

export const createTransform = (
    canvasPxWidth: number, canvasPxHeight: number,
    parameters: TransformParameters) => {

    const {
        sceneWidth, sceneHeight,
        variantViewboxX, variantViewboxY,
        variantViewboxWidth, variantViewboxHeight,
        designViewboxWidth, designViewboxHeight
    } = parameters;

    const designToSceneScale = calculateVariantToDesignScale(
        variantViewboxHeight, variantViewboxWidth,
        designViewboxHeight, designViewboxWidth);

    const sceneXAxisToPx = canvasPxWidth / sceneWidth;
    const sceneYAxisToPx = canvasPxHeight / sceneHeight;

    const scale = {
        x: sceneXAxisToPx * designToSceneScale,
        y: sceneYAxisToPx * designToSceneScale
    };

    const removeFfCanvasOriginX = Math.floor(-0.5 * canvasPxWidth);
    const removeFfCanvasOriginY = Math.floor(-0.5 * canvasPxHeight);

    const sceneCenterX = 0.5 * sceneWidth;
    const sceneCenterY = 0.5 * sceneHeight;

    const translate = {
        x: Math.floor(removeFfCanvasOriginX + (sceneCenterX + variantViewboxX) / designToSceneScale),
        y: Math.floor(removeFfCanvasOriginY + (sceneCenterY + variantViewboxY) / designToSceneScale)
    };

    return new Transform(scale, translate);
};

// UndoViewbox may only be used for background
// Other objects should use a different pipeline transform based on scene width and height,
// otherwise properties such as fontSize won't scale properly
export const createUndoViewbox = (parameters: TransformParameters): UndoViewbox => {

    const {
        variantViewboxX, variantViewboxY,
        variantViewboxWidth, variantViewboxHeight,
        designViewboxWidth, designViewboxHeight
    } = parameters;

    const designToSceneScale = calculateVariantToDesignScale(
        variantViewboxHeight, variantViewboxWidth,
        designViewboxHeight, designViewboxWidth);

    return {
        scaling: 1 / designToSceneScale,
        offsetX: -variantViewboxX / designToSceneScale,
        offsetY: -variantViewboxY / designToSceneScale
    };
};